export const RESEND_AGREEMENT = gql`
    mutation ResendAgreement($applicationId: Int!) {
        resendAgreement(applicationId: $applicationId)
    }
`;
